<app-text-input
  *ngIf="propertyForm"
  [disabled]="!property.Rules.EnableIf"
  [inputControl]="propertyForm"
  [labelTextId]="propertyType.NameId ? (propertyType.NameId | translate) : property.Key"
  [propertyKey]="property.Key"
  [placeholder]="placeholder"
  [readOnly]="property.Rules.ReadOnlyIf"
  [required]="property.Rules.RequiredIf"
  [showLengthCounter]="false"
  [tooltipTextId]="propertyType | tooltipTextId"
  [tooltipPosition]="'above'"
  (focusChange)="focused = $event"
>
  <div *ngFor="let message of messages">
    <div
      [ngClass]="{
        'ac-form-field-message-error': message.Properties['Level']?.Value === 0,
        'ac-form-field-message-warning': message.Properties['Level']?.Value === 1,
        'ac-form-field-message-info': message.Properties['Level']?.Value === 2
      }"
    >
      {{ message.Properties['Text']?.Value || (message.Properties['TextId']?.Value | translate) }}
    </div>
  </div>
</app-text-input>
